var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTradeDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.473 11.313c0-1.306-1.054-1.817-1.824-2.19l-.002-.001c-.389-.188-.791-.383-.791-.578 0-.213.03-.342.434-.342.307 0 .555.12.888.427l.21.193 1.106-1.31-.163-.176c-.42-.46-.883-.747-1.41-.877V5.377H8.354v1.11c-.954.284-1.517 1.065-1.517 2.129 0 1.215 1.013 1.74 1.752 2.124l.004.002c.438.229.852.444.852.687 0 .215-.037.377-.504.377-.384 0-.766-.162-1.236-.53l-.238-.184-.962 1.513.167.155c.489.455 1.152.711 1.682.817v1.046h1.567v-1.122c.976-.303 1.552-1.105 1.552-2.188zM3 10a6 6 0 1 1 12 0 6 6 0 0 1-12 0zm13.87-6a8.006 8.006 0 0 1 7.654 5.636L26 9.215l-1.474 3.556-3.442-2.153 1.505-.43A5.999 5.999 0 0 0 16.87 6V4zm1.562 16L21 23.738 23.568 20 21 16.262 18.432 20zM15 20a6 6 0 0 1 6-6 6 6 0 1 1-6 6zm-7.59-.187 1.505-.43-3.423-2.107L4 20.788l1.475-.422A8.01 8.01 0 0 0 13.13 26v-2a6.002 6.002 0 0 1-5.72-4.187z",
    fill: "url(#0n5z6901na)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0n5z6901na",
    x1: 3.117,
    y1: 4,
    x2: 3.117,
    y2: 25.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83C89"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTradeDark);
export default __webpack_public_path__ + "static/media/ic-trade-dark.830f10a041f16095c9038b41537724da.svg";
export { ForwardRef as ReactComponent };